<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
            title-text="消息发送历史"
            :headers="header"
            :get-data-func="getMessageLog"
            search-text="搜索收信号码">
          </l-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {time} from '../../ladmin/utils/time'
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
export default {
  name: 'templateList',
  components: {LDataTable},
  data () {
    return {
      selected: [],
      header: [
        {text: '收信号码', value: 'receiver', align: 'left', tooltip: true,placeholder:'N/A'},
        {text: '发送内容', value: 'paramJson', align: 'right', maxWidth: '28em', tooltip: true},
        {text: '模板代码', value: 'templateId', align: 'right', maxWidth: '7em', tooltip: true},
        {text: '发送方', value: 'sender', align: 'right'},
        {text: '发送时间', value: 'creationTime', align: 'right',f:(v)=>time.stringify(v)},
      ],
    }
  },
  methods: {
    async getMessageLog ({pagination, sortStack, filterItems = [], search}) {
      let {items,amount} = await this.$store.dispatch('messageManagement/getMessageLog', {pagination: pagination, search:{key:'receiver',value:search}})
      return {items:items,amount:amount}
     /* let searchParam = {
        'receiver': {
          'type': {
            'keyword': search,
            'order': 'ASC'
          },
        }
      }
      let res = await this.$store.dispatch('messageManagement/getMessageLog', {pagination: pagination, searchParam: searchParam})
      if (res.data.status === 1) {
        return {items: res.data.data.content, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因：' + res.data.msg})
      }*/
    },
  }
}
</script>
